import './resultPreviewScreen.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import CommonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import Grid from '@mui/material/Grid';
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ResultPreviewTableListComponent from "./result-preview-table-list/resultPreviewTableListComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import FileDragAndDropComponent from "../../../shared/components/file-drag-n-drop/FileDragAndDropComponent";
import FeedbackComponent from "../../../shared/components/feedback/feedbackComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import AutoCompleteDropdownComponent
    from "../../../shared/components/core/auto-complete-dropdown/autoCompleteDropdownComponent";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import commonService from "../../../shared/services/common.service";
import {IRootReducerState} from "../../../store/reducers";

interface ResultPreviewComponentProps {

}

const MODULE_NAME = 'ResultPreviewTableListComponent';

const ResultPreviewScreen = (props: ResultPreviewComponentProps) => {
        const params = useParams<{ sessionID: string }>();
        const [searchParams] = useSearchParams();

        const {sessionID} = params;
        const [sessionDetails, setSessionDetails] = useState<any>(undefined);
        const [isSessionDetailsLoading, setIsSessionDetailsLoading] = useState<boolean>(false);
        const [isSessionDetailsLoaded, setIsSessionDetailsLoaded] = useState<boolean>(false);
        const [isSessionDetailsLoadingFailed, setIsSessionDetailsLoadingFailed] = useState<boolean>(false);
        const [isUploadXlsDialogOpen, showUploadXlsDialogOpen] = useState<boolean>(false);
        const [isGeneratedResultCountDialogOpen, setGeneratedResultCountDialogOpen] = useState<boolean>(false);
        const [resultAttachmentFile, setResultAttachmentFile] = useState<File | undefined>(undefined);
        const [isAttachmentBeingUploaded, setIsAttachmentBeingUploaded] = useState<boolean>(false);
        const [testId, setTestId] = React.useState<any>(undefined);
        const [generatedResultCount, setGeneratedResultCount] = useState<number>(0);
        const [totalResultCount, setTotalResultCount] = useState<number>(0)
        const {testListLite} = useSelector((state: IRootReducerState) => state.staticData);

        const [isGenerateResultLoading, setIsGenerateResultLoading] = useState<boolean>(false);
        const [isGenerateButtonDisable, setIsGenerateButtonDisable] = useState<boolean>(true);

        const dispatch = useDispatch();
        const navigate = useNavigate();

        useEffect(() => {
            if (sessionID) {
                dispatch(setCurrentNavParams("Back", "Result", CommonService._routeConfig.ResultListRoute()));
                dispatch(setSideMenuView('compact'));
            }
        }, [sessionID, dispatch]);

        const getSessionDetails = useCallback(() => {
            const payload = {};
            let sessionDetails: any = {};
            setIsSessionDetailsLoading(true);
            setIsSessionDetailsLoaded(false);
            setIsSessionDetailsLoadingFailed(false);
            CommonService._result.getSessionDetails(sessionID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        sessionDetails = response.data;
                        setTestId(sessionDetails?.testDetails);
                    }
                    if (sessionDetails.isGenerateRequestSubmitted || sessionDetails.numberOfSamplesUnMatched > 0) {
                        setIsGenerateButtonDisable(false);
                    } else {
                        setIsGenerateButtonDisable(true);
                    }
                    setSessionDetails(sessionDetails);
                    setIsSessionDetailsLoading(false);
                    setIsSessionDetailsLoaded(true);
                    setIsSessionDetailsLoadingFailed(false);
                })
                .catch((error: any) => {
                    setSessionDetails(sessionDetails);
                    setIsSessionDetailsLoading(false);
                    setIsSessionDetailsLoaded(false);
                    setIsSessionDetailsLoadingFailed(true);
                });
        }, [sessionID]);

        const generateResult = useCallback(() => {
            const payload: any = {};
            if (searchParams.get('labOsResultLogId')) {
                payload['labOsResultLogId'] = searchParams.get('labOsResultLogId')
            }
            CommonService._result.generateResult(sessionID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        getSessionDetails();
                    }
                })
                .catch((error: any) => {
                    setIsGenerateResultLoading(false);
                });

        }, [sessionID, getSessionDetails, searchParams]);


        const handleGenerateResult = useCallback(() => {
            const payload:any = {};
            if (searchParams.get('labOsResultLogId')) {
                payload['labOsResultLogId'] = searchParams.get('labOsResultLogId')
            }
            setIsGenerateResultLoading(true);
            CommonService._result.generateResult(sessionID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        getSessionDetails();
                        let totalResultCount = 0;
                        let generatedResultCount = 0;
                        let setIntervalVal: any = null;
                        setIntervalVal = setInterval(() => {
                            if (totalResultCount === -1) {
                                setIsGenerateResultLoading(false);
                                clearInterval(setIntervalVal);
                            }
                            if (totalResultCount === 0) {
                                const payload = {};
                                CommonService._result.getGeneratedResultCount(sessionID, payload)
                                    .then((response: IAPIResponseType<any>) => {
                                        if (response?.data) {
                                            totalResultCount = response.data.totalCount;
                                            generatedResultCount = response.data.generatedCount;
                                            setTotalResultCount(totalResultCount);
                                            setGeneratedResultCount(generatedResultCount);
                                            setGeneratedResultCountDialogOpen(true);
                                            generateResult();
                                        }
                                    })
                                    .catch(() => {
                                        setGeneratedResultCountDialogOpen(false);
                                        setIsGenerateResultLoading(false);
                                        clearInterval(setIntervalVal);
                                    })
                            } else {
                                if (totalResultCount > generatedResultCount) {
                                    const payload = {};
                                    CommonService._result.getGeneratedResultCount(sessionID, payload)
                                        .then((response: IAPIResponseType<any>) => {
                                            if (response?.data) {
                                                totalResultCount = response.data.totalCount;
                                                generatedResultCount = response.data.generatedCount;
                                                setGeneratedResultCount(generatedResultCount);
                                            }
                                            CommonService._communications.TableWrapperRefreshSubject.next({
                                                moduleName: MODULE_NAME
                                            });
                                        })
                                        .catch(() => {
                                            setGeneratedResultCountDialogOpen(false);
                                            setIsGenerateResultLoading(false);
                                            clearInterval(setIntervalVal);
                                        })
                                } else {
                                    setGeneratedResultCountDialogOpen(false);
                                    // getSessionDetails();
                                    clearInterval(setIntervalVal);
                                    setIsGenerateResultLoading(false);
                                }
                            }
                        }, 1000)
                    }
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || 'Unable to generate result', 'error')
                    setIsGenerateResultLoading(false);
                });
        }, [searchParams, sessionID, getSessionDetails, generateResult]);


        const handleResultFilesDrop = useCallback((files: any) => {
            const file = files[0];
            setResultAttachmentFile(file);
        }, []);

        const openUploadXlsDialogComponent = () => {
            showUploadXlsDialogOpen(true);
        }

        const closeUploadXlsDialogComponent = useCallback(() => {
            setTestId(undefined);
            setResultAttachmentFile(undefined);
            showUploadXlsDialogOpen(false);
        }, [setTestId, setResultAttachmentFile, showUploadXlsDialogOpen])

        const uploadXlsResult = useCallback(() => {
            const formData = new FormData();
            if (resultAttachmentFile) {
                formData.append('file', resultAttachmentFile);
            }
            formData.append('testId', testId?.id);
            setIsAttachmentBeingUploaded(true);
            CommonService._result.uploadResultXlsx(formData)
                .then((response: IAPIResponseType<any>) => {
                    if (response.success) {
                        navigate(CommonService._routeConfig.ResultPreviewRoute(response.data.id));
                        closeUploadXlsDialogComponent();
                        setIsAttachmentBeingUploaded(false);
                    }
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading order attachment', "error");
                    setIsAttachmentBeingUploaded(false);
                })

        }, [resultAttachmentFile, testId, navigate, closeUploadXlsDialogComponent]);

        useEffect(() => {
            if (sessionID) {
                getSessionDetails();
            }
        }, [sessionID, getSessionDetails]);

        return (

            <div className="session-details-screen view-screen screen mrg-left-30 mrg-right-30">
                <div className="view-details-wrapper">
                    {
                        isSessionDetailsLoading && <div className="h-v-center">
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.LoadingLottieFile}/>
                        </div>
                    }
                    {
                        isSessionDetailsLoadingFailed && <>
                            <StatusCardComponent title={"Session details failed to load"}/>
                        </>
                    }
                    {
                        isSessionDetailsLoaded && <>
                            <>
                                <CardComponent>
                                    <div className="card-content">
                                        <div className="view-details-card-header-button-wrapper">
                                            <div className="view-details-card-title">
                                                {sessionDetails?.testDetails?.name}
                                            </div>
                                            <div className="view-details-options d-flex justify-content-space-between">
                                                <ButtonComponent
                                                    type="button"
                                                    color={"primary"}
                                                    disabled={!(sessionDetails?.numberOfSamplesUnMatched > 0)}
                                                    variant={"outlined"}
                                                    handleClick={openUploadXlsDialogComponent}
                                                >
                                                    Re-upload XLS
                                                </ButtonComponent>
                                                <ButtonComponent
                                                    type="button"
                                                    color={"primary"}
                                                    disabled={!isGenerateButtonDisable}
                                                    isLoading={isGenerateResultLoading}
                                                    variant={"contained"}
                                                    handleClick={handleGenerateResult}
                                                >
                                                    Generate Results
                                                </ButtonComponent>
                                            </div>
                                        </div>
                                        <div className="view-details-content">
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={2}>
                                                    <DetailsDataKeyValueComponent
                                                        title={"Added On"}>
                                                        <div
                                                            className="view-details-value"> {commonService.formatDate(sessionDetails?.createdAt)} </div>
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <DetailsDataKeyValueComponent
                                                        title={"Added by"}>
                                                        <div
                                                            className="view-details-value">{sessionDetails?.createdByDetails?.firstName + " " + sessionDetails?.createdByDetails?.lastName}</div>
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <DetailsDataKeyValueComponent
                                                        title={"Test Orders"}>
                                                        <div
                                                            className="view-details-value"> {sessionDetails?.numberOfSamples}</div>
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <DetailsDataKeyValueComponent
                                                        title={"Matched"}>
                                                        <div
                                                            className="details-value">{sessionDetails?.numberOfSamplesMatched} </div>
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <DetailsDataKeyValueComponent
                                                        title={"Unmatched"}>
                                                        <div
                                                            className="details-value"> {sessionDetails?.numberOfSamplesUnMatched} </div>
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </CardComponent>

                                <div className="session-table">
                                    <ResultPreviewTableListComponent sessionID={sessionID}/>
                                </div>
                            </>
                        </>
                    }
                </div>
                <DialogComponent open={isUploadXlsDialogOpen}
                                 onClose={closeUploadXlsDialogComponent}
                                 title="Re-upload the XLS or CSV file for generating the results"
                                 isShowCancel={true}
                                 maxWidth={"sm"}>
                    <div className="file-upload-wrapper mrg-top-10">
                        {/*<SelectDropdownComponent*/}
                        {/*    name={'panel'}*/}
                        {/*    label={'Select test panel'}*/}
                        {/*    isDataLoading={isTestPanelListLoading}*/}
                        {/*    isDataLoadingFailed={isTestPanelListLoadingFailed}*/}
                        {/*    isDataLoaded={isTestPanelListLoaded}*/}
                        {/*    required={true}*/}
                        {/*    options={testPanelList}*/}
                        {/*    valueKey={'id'}*/}
                        {/*    value={testId}*/}
                        {/*    onUpdate={(value: any) => setTestId(value)}*/}
                        {/*/>*/}

                        <AutoCompleteDropdownComponent
                            fullWidth={true}
                            name={'test'}
                            label={'Select Test'}
                            required={true}
                            multiple={false}
                            data={testListLite}
                            valueKey={'id'}
                            value={testId}
                            onSelectUpdate={(value: any) => {
                                setTestId(value)
                            }}
                            getOptionLabel={(option => (option.name) || '')}
                        />
                        {!resultAttachmentFile &&
                            <FileDragAndDropComponent onFilesDrop={handleResultFilesDrop}
                                                      acceptedFileTypes={{
                                                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
                                                          'text/csv': []
                                                      }}
                                                      fileSizeLimitText={'XLS or CSV smaller than 5MB'}
                            />
                        }
                        <div className="file-upload-selected-file-action-buttons-wrapper">
                            <div className="file-upload-selected-files-details">
                                {resultAttachmentFile &&
                                    <FeedbackComponent>{resultAttachmentFile?.name}</FeedbackComponent>
                                }
                            </div>
                            <div className="file-upload-action-buttons">
                                <ButtonComponent variant={"outlined"} handleClick={closeUploadXlsDialogComponent}
                                                 disabled={isAttachmentBeingUploaded}
                                                 fullWidth={true}
                                                 color={"primary"}>Cancel
                                </ButtonComponent>&nbsp;
                                <ButtonComponent variant={"contained"}
                                                 handleClick={uploadXlsResult}
                                                 disabled={isAttachmentBeingUploaded || !resultAttachmentFile}
                                                 isLoading={isAttachmentBeingUploaded}
                                                 fullWidth={true}
                                                 color={"primary"}
                                >
                                    Proceed
                                </ButtonComponent>
                            </div>
                        </div>
                    </div>
                </DialogComponent>
                <DialogComponent
                    open={isGeneratedResultCountDialogOpen}
                    direction={"down"}
                    isShowCancel={false}
                    maxWidth={'sm'}
                >
                    <>
                        <div className={'result-preview-dialog'}>
                            <div className={'result-preview-dialog-image-wrapper'}>
                                <img src={ImageConfig.resultDialogImage} alt={'result'} className="result-dialog-image"/>
                            </div>
                            <div className={'result-preview-dialog-content-wrapper'}>
                                {generatedResultCount} / {totalResultCount}
                            </div>
                            <div className={'result-preview-dialog-content-sub-header'}>
                                Reports are being generated...
                            </div>
                            <div className={'result-preview-dialog-close-button'}>
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    fullWidth={true}
                                    handleClick={() => navigate(CommonService._routeConfig.ResultListRoute())}
                                >
                                    Back to Result
                                </ButtonComponent>
                            </div>
                        </div>
                    </>
                </DialogComponent>
            </div>
        )
    }

;

export default ResultPreviewScreen;
